import { render, staticRenderFns } from "./tipologieGruppiMail.vue?vue&type=template&id=3990690a&scoped=true&"
import script from "./tipologieGruppiMail.vue?vue&type=script&lang=js&"
export * from "./tipologieGruppiMail.vue?vue&type=script&lang=js&"
import style0 from "./tipologieGruppiMail.vue?vue&type=style&index=0&id=3990690a&scoped=true&lang=css&"
import style1 from "./tipologieGruppiMail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990690a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBottomSheet,VBtn,VCol,VIcon,VImg,VListItem,VListItemAvatar,VListItemTitle,VRow,VSheet,VTextField})
